/**
 * チェックしたアイテムをローカルストレージで管理
 */

const STORAGE_KEY = 'checkedItems'
const MAX_ITEMS = 10

export const addCheckedItem = (uuid: string): void => {
  if (typeof window === 'undefined') return

  try {
    const items = getCheckedItems()

    // 既に存在する場合は削除（最新を先頭に追加するため）
    const filteredItems = items.filter((item) => item !== uuid)

    // 新しいアイテムを先頭に追加
    const newItems = [uuid, ...filteredItems]

    // 最大件数を超えた場合は古いものを削除
    const limitedItems = newItems.slice(0, MAX_ITEMS)

    localStorage.setItem(STORAGE_KEY, JSON.stringify(limitedItems))
  } catch (error) {
    console.error('Failed to save checked item:', error)
  }
}

export const getCheckedItems = (): string[] => {
  if (typeof window === 'undefined') return []

  try {
    const items = localStorage.getItem(STORAGE_KEY)
    return items ? JSON.parse(items) : []
  } catch (error) {
    console.error('Failed to get checked items:', error)
    return []
  }
}

export const removeCheckedItem = (uuid: string): void => {
  if (typeof window === 'undefined') return

  try {
    const items = getCheckedItems()
    const filteredItems = items.filter((item) => item !== uuid)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filteredItems))
  } catch (error) {
    console.error('Failed to remove checked item:', error)
  }
}

export const clearCheckedItems = (): void => {
  if (typeof window === 'undefined') return

  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (error) {
    console.error('Failed to clear checked items:', error)
  }
}
